import React from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import commonCoreLazyI18nMessages from '../i18n/lazy';
import { getCodesFromLocale, useLazyI18nMessages } from './utils';
export const DEFAULT_LOCALE = 'en-US';
export const ProFormaIntlProvider = ({
  children,
  i18nMessages,
  locale
}) => {
  var _ref, _ref2;
  // `commonCoreI18nMessages` is a temporary variable required only while we need to maintain
  // access to the 'proforma-common-core' translations for other packages. Once the translations
  // are properly per package, this can be removed.
  const commonCoreI18nMessages = useLazyI18nMessages(locale, commonCoreLazyI18nMessages);
  if (!commonCoreI18nMessages) {
    return null;
  }
  const {
    language,
    country
  } = getCodesFromLocale(locale);
  const messages = (_ref = (_ref2 = country && i18nMessages[`${language}_${country}`]) !== null && _ref2 !== void 0 ? _ref2 : i18nMessages[language]) !== null && _ref !== void 0 ? _ref : i18nMessages.en;
  // `aggregateMessages` is a temporary variable required only while we need to maintain
  // access to the 'proforma-common-core' translations for other packages. Once the translations
  // are properly per package, this can be removed.
  const aggregateMessages = {
    ...commonCoreI18nMessages,
    ...messages
  };
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: aggregateMessages,
    locale: country ? `${language}-${country}` : language,
    defaultLocale: DEFAULT_LOCALE,
    defaultRichTextElements: {
      b: chunks => /*#__PURE__*/React.createElement("b", null, chunks),
      strong: chunks => /*#__PURE__*/React.createElement("strong", null, chunks)
    }
  }, children);
};
export const withProFormaIntlProvider = (i18nMessages, WrappedComponent) => props => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(ProFormaIntlProvider, {
    i18nMessages: i18nMessages,
    locale: intl.locale
  }, /*#__PURE__*/React.createElement(WrappedComponent, props));
};